 import "./ProductTitle.css";
import { Link } from "react-router-dom";

export default function ProductTitle({
  product,
  selectors = [],
  selectedVariation,
}) {
  return (
    <div className="product-title-show">
      <div className="product-title-page">
        
          <h3>
            {product.name}

            {selectedVariation?.label &&
              selectedVariation.label !== "بدون ویژگی" && (
                <span className="variation-label">
                  {" ("}
                  {selectedVariation.label}
                  {")"}
                </span>
              )}
          </h3>
            <h4>{product.nameEn}</h4>
             <h5>
            <Link
              to={`/products?brand=${product.brand.id}`}
              className="brand-link-page"
            >
              {product.brand.slug}
            </Link>
          </h5>
    
       
      </div>
    </div>
  );
}
